import { render, staticRenderFns } from "./ResetAdminPasswordSidebar.vue?vue&type=template&id=efac50bc&scoped=true&"
import script from "./ResetAdminPasswordSidebar.vue?vue&type=script&lang=js&"
export * from "./ResetAdminPasswordSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ResetAdminPasswordSidebar.vue?vue&type=style&index=0&id=efac50bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efac50bc",
  null
  
)

export default component.exports